namespace advisorop.services {
    `use strict`;

    export class WorkflowApi {

        readonly apiUrl = `/api/workflow`;
        
        static $inject = [`$http`];
        constructor(private $http: ng.IHttpService) {
        }       

        getWorkflows(advisoryFirmId: number, getShapesAndConnectors: boolean = true, includeTaskSummaryInfo: boolean = false, workflowMasterId: number = null): ng.IHttpPromise<any[]> {
            // Send 0 workflowMasterId to get all masters, otherwise specify MasterId > 0 to get individual master
            workflowMasterId = workflowMasterId ?? 0;
            return this.$http.get(`${this.apiUrl}/masters/${advisoryFirmId}/${getShapesAndConnectors}/${includeTaskSummaryInfo}/${workflowMasterId}`);
        }

        createWorkflow(model: domains.IWorkflowMaster): ng.IHttpPromise<{}> {
            return this.$http.post(`${this.apiUrl}/createworkflowmaster`, model);
        }

        updateWorkflow(model: domains.IWorkflowMaster): ng.IHttpPromise<{}> {
            //console.log("MAKING API CALL TO UPDATE THIS MODEL", model);
            return this.$http.post(`${this.apiUrl}/updateworkflowmaster`, model);
        }

        createWorkflowInstance(model: domains.IWorkflowInstance): ng.IHttpPromise<{}> {
            return this.$http.post(`${this.apiUrl}/createworkflowinstance`, model);
        }

        getWorkflowMaster(workflowMasterId: number): ng.IHttpPromise<any[]> {
            return this.$http.get(`${this.apiUrl}/master/${workflowMasterId}`);
        }

        getWorkflowInstances(workflowMasterId: number): ng.IHttpPromise<any[]> {
            return this.$http.get(`${this.apiUrl}/instances/${workflowMasterId}`);
        }

        getWorkflowInstance(workflowInstanceId: number): ng.IHttpPromise<any[]> {
            return this.$http.get(`${this.apiUrl}/instance/${workflowInstanceId}`);
        }

        claimStep(stepId: number): ng.IHttpPromise<domains.IWorkflowInstance> {
            return this.$http.post(`${this.apiUrl}/step/${stepId}/claim`, null);
        }

        unClaimStep(stepId: number): ng.IHttpPromise<domains.IWorkflowInstance> {
            return this.$http.post(`${this.apiUrl}/step/${stepId}/unclaim`, null);
        }

        completeStep(stepId: number): ng.IHttpPromise<domains.IWorkflowInstance> {
            return this.$http.post(`${this.apiUrl}/step/${stepId}/complete`, null);
        }

        decisionPositive(stepId: number): ng.IHttpPromise<domains.IWorkflowInstance> {
            return this.$http.post(`${this.apiUrl}/step/${stepId}/decisionpositive`, null);
        }

        decisionNegative(stepId: number): ng.IHttpPromise<domains.IWorkflowInstance> {
            return this.$http.post(`${this.apiUrl}/step/${stepId}/decisionnegative`, null);
        }

        undoCompleteStep(stepId: number): ng.IHttpPromise<domains.IWorkflowInstance> {
            return this.$http.post(`${this.apiUrl}/step/${stepId}/undo`, null);
        }

        stealStep(stepId: number): ng.IHttpPromise<domains.IWorkflowInstance> {
            return this.$http.post(`${this.apiUrl}/step/${stepId}/steal`, null);
        }

        skipActivity(activityId: number): ng.IHttpPromise<domains.AccountLifeCycleViewModel> {
            return this.$http.post(`${this.apiUrl}/activity/${activityId}/skip`, null);
        }

        updateNotes(lifeCycleViewModel: domains.AccountLifeCycleViewModel): ng.IHttpPromise<domains.AccountLifeCycleViewModel> {
            return this.$http.post(`${this.apiUrl}/activity/updatenotes`, lifeCycleViewModel);
        }


    }
    angular.module(Constants.ADVOP_SERVICES).service("workflowApi", WorkflowApi);
}
